import classnames from 'classnames';
import { useContext } from 'react';
import { ConfigContext } from 'palette/Config';
import { Svg } from 'palette/Svg';
import { Size, LogoName } from './constants';
import './Logo.scss';

export interface LogoProps {
    size?: Size;
    name: LogoName;
    className?: string;
    svgUrl?: string;
}

function Logo({
    size,
    name,
    className,
    svgUrl,
}: LogoProps) {
    const { logoPath } = useContext(ConfigContext);
    const rootClasses = classnames(
        'logo',
        className,
        { [`logo--size--${size}`]: size !== undefined },
    );

    return (
        <div className={rootClasses}>
            <Svg
                name={name}
                svgUrl={svgUrl ?? logoPath ?? ''}
            />
        </div>
    );
}

export default Logo;
